import { Dispatch, SetStateAction } from 'react';
import { TabType } from '../../DatePicker.types';
import { DatePickerButton } from '../datePickerButton';
import { DaysRowHeader } from '../daysRowHeader';
import { MonthDaysGrid } from '../monthDaysGrid';

export interface daysRowHeaderProps {
  weekDays: string[];
}

export interface monthDaysGridProps {
  monthDays: Date[][];
  selectedMonth: number;
  selectedDate: Date | null;
  onClick: (e: React.MouseEvent<HTMLElement>) => void;
  isAllowedDateToSelect?: (d: Date) => boolean;
}

export interface DatePickerNoticeProps {
  label: string;
}

interface dayTabProps {
  selectedYear: number;
  currentMonth: string;
  weekDays: string[];
  daysRowHeaderProps: daysRowHeaderProps;
  monthDaysGridProps: monthDaysGridProps;
  datePickerNoticeProps: DatePickerNoticeProps;
  setSelectionTab: Dispatch<SetStateAction<TabType>>;
  onNavClickPrev: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onNavClickNext: (e: React.MouseEvent<HTMLButtonElement>) => void;
  isAllowedDateToSelect?: (d: Date) => boolean;
}

export const DayTab: React.FC<dayTabProps> = ({
  selectedYear,
  currentMonth,
  daysRowHeaderProps,
  monthDaysGridProps,
  setSelectionTab,
  onNavClickPrev,
  onNavClickNext,
  isAllowedDateToSelect = () => true,
}) => {
  const changeSelectionTab = (
    e: React.MouseEvent<HTMLElement> | null = null,
    tab: TabType,
  ) => {
    if (e) {
      e.preventDefault();
    }

    setSelectionTab(tab);
  };

  return (
    <div data-testid={'days-tab'}>
      <div className="flex justify-between items-center">
        <DatePickerButton
          buttonType="arrow-button"
          arrowDirection="left"
          onClick={onNavClickPrev}
          testID={'prev'}
        />
        <div>
          <DatePickerButton
            label={currentMonth}
            onClick={(e) => changeSelectionTab(e, 'month')}
            testID={'select-month'}
          />
          <DatePickerButton
            label={selectedYear}
            onClick={(e) => {
              changeSelectionTab(e, 'year');
            }}
            testID={'select-year'}
          />
        </div>
        <DatePickerButton
          buttonType="arrow-button"
          arrowDirection="right"
          onClick={onNavClickNext}
          testID={'next'}
        />
      </div>
      <table className="w-full">
        <DaysRowHeader weekDays={daysRowHeaderProps.weekDays} />
        <MonthDaysGrid
          monthDays={monthDaysGridProps.monthDays}
          selectedMonth={monthDaysGridProps.selectedMonth}
          selectedDate={monthDaysGridProps.selectedDate}
          onClick={monthDaysGridProps.onClick}
          isAllowedDateToSelect={isAllowedDateToSelect}
        />
      </table>
    </div>
  );
};
